import urls from "../constants";
import { useFetch } from "./useFetch";

export function useTestimonies() {
    const { sendGet, sendPost } = useFetch();

    const getTestimonies = async (token) => {        
        try {
            const response = await sendGet(urls.GET_TESTIMONIES, {
                    AccessToken: token
                }
            );
            return response.map(item => ({
                ...item,
                createdDate: new Date(item.createdDate)
            }));
        } 
        catch (error) {
            console.error(error);
            return [];
        }
    }

    const updateTestimonyStatus = async (token, testimonyID, status) => {
        try {
            const updatedTestimony = await sendPost(urls.UPDATE_TESTIMONY_STATUS, {
                    AccessToken: token
                },              
                JSON.stringify({testimonyID, status})
            );
            return {...updatedTestimony, createdDate: new Date(updatedTestimony.createdDate)};
        } 
        catch (error) {
            console.error(error);
            throw error;
        }
    }

    return { getTestimonies, updateTestimonyStatus };
}